import React, { useCallback,useMemo,useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { 
  Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
  TextField
} from '@mui/material';
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import Moment from 'react-moment';
import {List } from '@mui/icons-material';
import { Row, Col } from "react-bootstrap";
import CsvDownloadButton from 'react-json-to-csv'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { useNavigate, Link, useParams , useSearchParams } from "react-router-dom";
import * as AuthVerify from '../../lib/common';

const CustomTable = ({ globalSearch=false }) => {
  const navigate = useNavigate();    
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [b2cUser, setB2cUser] = useState(false);
  const [apiData, setApiData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    arnum: 'contains',
    donum : 'contains',
    ordernum: 'contains',
    status: 'contains',
    createdat: 'lessThan',
    deldate: 'lessThan'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  const findFilterCondition = (name) =>{
    var condition = '';
    if(columnFilterFns[name]){
      condition = columnFilterFns[name];
    }
    return condition;
  }

  const fetchDataFromAPI = async (reset=false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    
    let filterQuery='';
    let sorterQuery='';

    if(!reset){
      if(columnFilters.length>0){
        columnFilters.forEach(element => {
            if(element.id === 'submitteddate' || element.id === 'approveddate'){
              filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${AuthVerify.getDate(element.value)}`;
            }
            else{
              filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
            }
        });
      }
      if(sorting.length > 0){
        sorting.forEach(element => {
          sorterQuery+=`&sortby=${element.id}&orderby=${element.desc?'desc':'asc'}`;
        });
      }
    }else{
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    //Get Delivery Order List
    //api/account/deliveryorder/
    let url = `/account/deliveryorder?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.deliveryorders.items??[]);
          setRowCount(response.data?.data.deliveryorders.count);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };


  useEffect(() => {
    const user=AuthVerify.getUser();
    if(user.role=='Individual'){
      setB2cUser(true);
    }
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.ordernum,
        id: 'ordernum',
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnFilterModes: false,
        header: 'Order #',
        enableEditing : false,
        size:50,
        Cell: ({ cell, row }) => (
          // <a href="#">
          //   <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(row.original.imageurl)} alt="Product" />
          // </a>
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'donum',
        header: "Donum",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'arnum',
        header:  "Arnum",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'createdat',
        header:  "Created Date",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue() && cell.getValue().length>0 ? <Moment date={cell.getValue()} format="YYYY-MM-DD HH:mm:ss"/> : ""}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'lessThan',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
        Filter: ({ column, header, table }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: Less Than</p>
          </LocalizationProvider>
          
        ),
      },
      {
        accessorKey: 'deldate',
        header:  "Del Date",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue() && cell.getValue().length>0 ?<Moment date={cell.getValue()} format="YYYY-MM-DD HH:mm:ss"/>:""}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'lessThan',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
        Filter: ({ column, header, table }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: Less Than</p>
          </LocalizationProvider>
          
        ),
      },
      {
        accessorKey: 'status',
        header:  "Status",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      }
      //end
    ],
    [],
  );
  const b2cColumns = useMemo(
    () => [
      {
        accessorFn: (row) => row.refnum,
        id: 'refnum',
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnFilterModes: false,
        header: 'Order #',
        enableEditing : false,
        size:50,
        Cell: ({ cell, row }) => (
          // <a href="#">
          //   <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(row.original.imageurl)} alt="Product" />
          // </a>
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'submitteddate',
        header:  "Order Date",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue() && cell.getValue().length>0 ? <Moment date={cell.getValue()} format="YYYY-MM-DD HH:mm:ss"/> : ""}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'lessThan',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
        Filter: ({ column, header, table }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: Less Than</p>
          </LocalizationProvider>
          
        ),
      },
      {
        accessorKey: 'totalamt',
        header: "Amount",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'equals',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
      },
      {
        accessorKey: 'status',
        header: "Status",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      }
      //end
    ],
    [],
  );

  return (
    <>
        <MaterialReactTable
          columns={columns}
          data={data}
          enableColumnActions={false}
          enableGlobalFilter={false}
          enableColumnFilterModes
          initialState={{
            showColumnFilters: false
          }}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFilterFnsChange={setColumnFilterFns}
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          tableInstanceRef={tableInstanceRef}
          rowCount={rowCount}
          enableEditing
          state={{
            columnFilters,
            columnFilterFns,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
          }}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            'mrt-row-actions': {
              header: 'Action', //change header text
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Details">
              <IconButton onClick={() => navigate(`/delivery-order-details?donum=${row.original.donum}`)}>
                  <List />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          muiTableHeadCellProps={{
            sx: {
              // fontWeight: 'bold',
              fontSize: '15px',
            },
          }}
          muiTablePaginationProps={{
            sx: {
              fontWeight: 'bold',
              paddingTop: '12px',
              fontSize: '16px',
            },
          }}
          muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
            sx: {
              fontSize: '17px'
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              fontWeight: 'bold',
              fontSize: '17px',
            },
          }}
        />
    </>
  );
};

export default CustomTable;
